import deviceSettingsClient from '@/core/services/device-settings-service';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import {
  IDefaultDevicesSettingsDTO,
  ThermoRoomObjectDTO,
} from '@/../client-generator/generated-clients/device-settings';
import {
  getObjectIconFromType,
  getObjectDescLabel,
  getDeviceIconFromSettings,
} from '@/core/utils/utils';
import { Options } from 'vue-class-component';
import ThermoGeneralStep from '../ThermoGeneralStep';
import ThermoProbeSettings from '@/views/components/DeviceSettings/ThermoProbeSettings/ThermoProbeSettings.vue';

@Options({
  name: 'StepOverview',
  components: {
    ThermoProbeSettings,
  },
})
export default class StepOverview extends ThermoGeneralStep {
  getObjectIconFromType = getObjectIconFromType;
  getObjectDescLabel = getObjectDescLabel;
  getDeviceIconFromSettings = getDeviceIconFromSettings;

  showRightPanel = false;
  activeSettingsComponent = '';
  currentDefaultSetting: IDefaultDevicesSettingsDTO | null = null;
  currentDeviceName: string | null = null;

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      const response = await deviceSettingsClient.thermoDefault(
        this.roomObject.id!,
        ThermoRoomObjectDTO.fromJS(this.roomObject)
      );

      this.$emit('update:defaultSettings', response);
    } catch (error) {
      console.log(error);
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }
      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  hasDeviceSettingsButtonVisible(setting: IDefaultDevicesSettingsDTO) {
    return setting?.thermoProbeSettings != null;
  }

  openAdvancedSettings() {
    this.showRightPanel = true;
  }

  showDeviceSettings(setting: IDefaultDevicesSettingsDTO) {
    if (setting?.thermoProbeSettings != null) {
      this.activeSettingsComponent = 'ThermoProbeSettings';
    } else return;

    this.currentDefaultSetting = setting;
    this.currentDeviceName = this.getDeviceName(setting.deviceUid as string);
    this.showRightPanel = true;
  }

  getDeviceName(deviceUuid: string) {
    const device = this.roomObject.devices?.find((k) => k.uid === deviceUuid);
    if (!device) return '';
    return `${device.model} - ID ${device.id}`;
  }
}
